import { Avatar, Input } from '@material-ui/core';
import React, { useState, useEffect } from 'react'
import "./ChatScreen.css";
import axios from "./axios";

function ChatScreen() {

    const [input , setInput ] = useState("");
    const [messages, setMessages] = useState([]);

    useEffect(()=>{
      async function fetchData(){
        const req= await axios.get('/tinder/chats');
        setMessages(req.data);
      }
      fetchData();
    }, []);
  
     const handleSend = e=>{
         e.preventDefault();
         setMessages([...messages, {message:input}]);
     setInput('');
    }
    // ----------------------------------------------------------------------------------------------
    
    return (
        <div className="chatscreen">
            {/* <p className="chatScreen__timestamp">You matched with Dani on 10/3/21</p> */}
            {messages.map((message)=>
                message.name ? (
                    <>
                    <p className="chatScreen__timestamp">You matched with {message.name} on 10/3/21</p>
                <div className="chatScreen__message">
                <Avatar className="ChatScreen__image"
                alt={message.name}
                src={message.imgUrl} />
                 <p className="chatScreen__text">{message.message} </p>
                 </div>
                 </>
                 ): (
                     <div className="chatScreen__message">
                         <p className="chatScreen__textUser">{message.message}</p>
                     </div>
                 )
            )}
        
                <form className="chatScreen__input" >
                    <input 
                    value={input} 
                    onChange={(e)=> setInput(e.target.value)}
                    className="chatScreen__inputField" 
                    placeholder="Type a message..." 
                    type="text"/>
                    <button onClick={handleSend} className="chatScreen__inputButton">SEND</button>
                </form>

        </div>
    );
}

export default ChatScreen
